import JSZip from "jszip";
import { saveAs } from "file-saver";
import { BuildSessionTextsExcelBlob } from "./ExportToExcel";

const getImageSignedUrl = (it) =>
  it?.signed_url?.signed_url ??
  it?.signed_url ??
  it?.url?.signed_url ??
  it?.url ??
  "";

const getVideoSignedUrl = (it) =>
  it?.url?.signed_url ??
  it?.url ??
  "";

const fetchBlob = async (url) => {
  const res = await fetch(url, { method: "GET" });
  if (!res.ok) throw new Error(`Failed to fetch file: ${res.status}`);
  return res.blob();
};

const extFromTypeOrUrl = (blob, url, fallback = "bin") => {
  const type = blob?.type || "";

  if (type.includes("png")) return "png";
  if (type.includes("jpeg")) return "jpg";
  if (type.includes("jpg")) return "jpg";
  if (type.includes("webp")) return "webp";
  if (type.includes("mp4")) return "mp4";

  const cleanUrl = String(url || "").split("?")[0].toLowerCase();
  const parts = cleanUrl.split(".");
  return parts.length > 1 ? parts.pop() : fallback;
};

export const ExportSessionBundleZip = async ({
  categories,
  sessionId,
  generatedImages = [],
  mergedVideo = null,
}) => {
  const zip = new JSZip();

  const root = zip.folder(`session_${sessionId || "session"}`);
  const textFolder = root.folder("texts");
  const imageFolder = root.folder("images");
  const videoFolder = root.folder("videos");

  const excelBlob = BuildSessionTextsExcelBlob({ categories });
  textFolder.file(`session_texts_${sessionId || "session"}.xlsx`, excelBlob);

  const imageTasks = (generatedImages ?? []).map(async (img, idx) => {
    const url = getImageSignedUrl(img);
    if (!url) return;

    const blob = await fetchBlob(url);
    const ext = extFromTypeOrUrl(blob, url, "jpg");
    imageFolder.file(`image_${idx + 1}.${ext}`, blob);
  });

  const mergedVideoUrl = getVideoSignedUrl(mergedVideo);
  const videoTask = mergedVideoUrl
    ? (async () => {
        const blob = await fetchBlob(mergedVideoUrl);
        const ext = extFromTypeOrUrl(blob, mergedVideoUrl, "mp4");
        videoFolder.file(`merged_video.${ext}`, blob);
      })()
    : Promise.resolve();

  await Promise.all([...imageTasks, videoTask]);

  const zipBlob = await zip.generateAsync({ type: "blob" });
  saveAs(zipBlob, `session_${sessionId || "session"}.zip`);
};